export default __webpack_public_path__ + "static/media/TimoHelgert-1ETHM.a0e59aef.mp4";